export const MemberTrainEvaluationCn = {
    xunjiadang:'培训单评价',
    wodepingjia:'我的评价',
    daipingjia:'待评价订单',
    zuanjiaxinxi:'专家信息',
    pingjianeirong:'评价内容',
    pingjiazuantai:'评价状态',
    dingdangneirong:'订单内容',
    jiage:'价格',
    zhuantai:'状态',
    caozuo:'操作'
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/MemberTrainEvaluation/MemberTrainEvaluationCn.js